import { useState, useCallback } from 'react'

import { ToastProps } from '@/components/ui'

const useToast = () => {
  const [toast, setToast] = useState<Omit<ToastProps, 'show'>>({
    header: '',
    body: '',
    position: 'end',
    success: false,
    info: false,
    warning: false,
    actions: [],
  })
  const [show, setShow] = useState(false)

  const showToast = useCallback((options: Omit<ToastProps, 'show'>) => {
    setToast({ ...options })
    setShow(true)
  }, [])

  const hideToast = useCallback(() => {
    setShow(false)
  }, [])

  return {
    showToast,
    hideToast,
    toast,
    show,
  }
}

export default useToast
